import { cn } from "@sagot/ui";

/** "or" / "or sign up with" rule between form sections (the mockup's `.a-or`; the rule lines are CSS). */
export function AuthDivider({ label, className }: { label: string; className?: string }) {
  return <div className={cn("a-or", className)}>{label}</div>;
}
